// PackageHeader.js
import React from 'react';
import './package.css'; // Import CSS file for styling
import TranslateText from 'translation/TranslateText';
import { useLanguage } from '../../LanguageContext';

function PackageHeader() {
  const { language } = useLanguage();

  return (
    <div className="page-header-container">
      <div
        className="page-header section-dark"
        style={{
          backgroundImage: `url(${require("assets/img/Professional.jpg")})`,
          backgroundPosition: "center -160px",
          backgroundSize: "cover",
        }}
      >
        <div className="centered">
          <h1 className={`age inq ${language === 'es' ? 'spanish-styling' : ''}`}>
            <TranslateText text="Age Professional Tradeline Packages" />
          </h1>
        </div>
      </div>
    </div>
  );
}

export default PackageHeader;

// import React from 'react';
// import './package.css'; // Import CSS file for styling
// import TranslateText from 'translation/TranslateText';

// function PackageHeader() {
//   return (
//     <div className="page-header-container">
//       <div
//         className="page-header section-dark"
//         style={{
//           backgroundImage: `url(${require("assets/img/Professional.jpg")})`
//           ,
//           backgroundPosition: "center -160px",
//           backgroundSize: "cover",
//         }}
//       >
//         <div className="centered">
//           <h1 className='age inq'><TranslateText text="Age Professional Tradeline Packages" /></h1>
//         </div>
//       </div>
//     </div>
//   );
// }
// export default PackageHeader;
